import React from 'react';
import styled from 'styled-components';

const TextControl = styled.div`
    display: flex;
    width: 100%;
`;

const FloatInput = styled.div`
    display: grid;
    position: relative;
    width: 100%;
`;

const ValidationIndicator = styled.div`
    margin-top: 12px;
    margin-right: 5px;
    color: red;
    font-size: 24px;    
    user-select: none;
`

const InvalidMessage = styled.div`
    color: red;
    font-size: 10px;
    order: 4;
    margin-top: 2px;
`;

const FloatLabel = styled.div`
    font-size: 1.1em;
    font-weight: normal;
    opacity: 0.5;
    order: 1;
    white-space: nowrap;
    pointer-events: none;
    text-transform: capitalize;
    transform-origin: left top;
    transform: ${p => p.isFloating ? 'scale(0.8) translate3d(0, 2px, 0);' : 'scale(1) translate3d(0, 20px, 0);'};
    transition: 200ms ease all;
`;

const InputControl = styled.input`
    width: 100%;
    border: 2px solid ${p => p.isValid ? '#C8CFD2' : '#CE452D'};
    border-radius: 4px;
    box-sizing: border-box;
    outline: none;
    padding: 8px;
    font-size: 14px;
    line-height: 24px;
    &::placeholder{
        color: ${p => p.isDarkMode ? "rgba(255,255 , 255, 0.5)" : "rgba(0, 0, 0, 0.15)"};
    }
`;

interface FloatInputComponentProps {
    showErrors?: boolean;
    isValid?: boolean;
    invalidMessages?: string[];
    value: string;
    label: string;
    focusAction?: (e) => void;
    onChange?: (e) => void;
    changeAction?: (e) => void;
    enterKeyAction?: (e) => void;
    isDarkMode?: boolean;
    placeHolder?: string;
    autoFocus?: boolean;
}

const FloatInputComponent = ({
    showErrors,
    isValid,
    invalidMessages,
    value,
    label,
    focusAction,
    onChange,
    changeAction,
    enterKeyAction,
    isDarkMode,
    placeHolder,
    autoFocus }: FloatInputComponentProps) => {
    const isValidValue = isValid !== undefined ? isValid : true;
    return (
        <TextControl>
            {showErrors && !isValidValue ? <ValidationIndicator>•</ValidationIndicator> : null}
            <FloatInput>
                <InputControl
                    onChange={(e) => { onChange?.(e); changeAction?.(e); }}
                    onFocus={(e) => focusAction?.(e)}
                    value={value}
                    isDarkMode={isDarkMode}
                    autoFocus={autoFocus}
                    placeholder={placeHolder}
                    isValid={isValidValue}
                    onKeyUp={e => { if (e.key === 'Enter') enterKeyAction?.(e) } }
                />
                <FloatLabel isFloating={Boolean(value)}>{label}</FloatLabel>
                {showErrors && !isValidValue && invalidMessages && invalidMessages.length > 0 ? <InvalidMessage>{invalidMessages[0]}</InvalidMessage> : null}
            </FloatInput>
        </TextControl>);
}

export default FloatInputComponent;